import * as React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

function MUIButtonUploadImage({
  btnStyle,
  btnOnClick,
  btnLabel,
  children,
  btnType = "",
  disabledbtn = false,
}) {
  return (
    <div className="d-flex">
      <Button
        onClick={btnOnClick}
        type={btnType}
        disabled={disabledbtn}
        variant="contained"
        sx={{
          ...btnStyle,
          py: "6px",
          borderRadius: "10px",
          textTransform: "capitalize",
        }}
      >
        {children}
        <span style={{ fontSize: "16px" }}>{btnLabel}</span>
      </Button>
    </div>
  );
}

export default MUIButtonUploadImage;
